import { render, staticRenderFns } from "./DialogFormAssetAdd.vue?vue&type=template&id=2768cf47"
import script from "./DialogFormAssetAdd.vue?vue&type=script&lang=js"
export * from "./DialogFormAssetAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports